import { NotifyHelper } from "../../../helpers/toast";
import { objSucKhoeDefine } from "../../action-types/danh-muc/ISucKhoeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const sucKhoeActions = {
    ...generateActions(objSucKhoeDefine, "SUC_KHOE"),
    ...generateActionForKey(objSucKhoeDefine, "SUC_KHOE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objSucKhoeDefine, "SUC_KHOE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objSucKhoeDefine, "SUC_KHOE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objSucKhoeDefine, "SUC_KHOE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objSucKhoeDefine, "SUC_KHOE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
